import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

/**
 * Site-wide footer (legal links + copyright). Source of truth: landing page design.
 */
@Component({
  selector: 'app-site-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './site-footer.component.html',
})
export class SiteFooterComponent {
  /** When true, footer is visible from `lg` breakpoint only (app shell with mobile tab bar). */
  readonly desktopOnly = input(false);
}
